// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Pervasives from "../../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";

function mapToYesNo(v) {
  if (v) {
    return "Yes";
  } else {
    return "No";
  }
}

function getOpenOrderVm(order) {
  var v = order.from_state !== order.to_state;
  var is_editable = order.is_order_editable;
  return {
          is_helper_required: $$String.capitalize_ascii(Pervasives.string_of_bool(order.is_helper_order)),
          is_outstation_trip: $$String.capitalize_ascii(Pervasives.string_of_bool(order.is_outstation_order)),
          has_waypoints: $$String.capitalize_ascii(Pervasives.string_of_bool(order.has_waypoints)),
          is_interstate_order: v ? "Yes" : "No",
          is_return_trip: "N/A",
          booked_vehicle_type: order.vehicle.vehicle_type,
          is_helper_labour_order: $$String.capitalize_ascii(Pervasives.string_of_bool(order.is_helper_plus_labour)),
          is_rental_order: $$String.capitalize_ascii(Pervasives.string_of_bool(order.is_rental_order)),
          is_pfe_order: $$String.capitalize_ascii(Pervasives.string_of_bool(order.is_pfe_order)),
          is_otp_order: $$String.capitalize_ascii(Pervasives.string_of_bool(order.is_otp_order)),
          is_order_editable: is_editable !== undefined ? $$String.capitalize_ascii(Pervasives.string_of_bool(is_editable)) : "N/A"
        };
}

function getVm(order) {
  var order$1;
  var ended_order;
  switch (order.TAG | 0) {
    case /* Ended */3 :
        order$1 = order._0;
        ended_order = order._3;
        break;
    case /* CancelledEnded */8 :
        order$1 = order._0;
        ended_order = order._4;
        break;
    default:
      return getOpenOrderVm(order._0);
  }
  var init = getOpenOrderVm(order$1);
  return {
          is_helper_required: init.is_helper_required,
          is_outstation_trip: init.is_outstation_trip,
          has_waypoints: init.has_waypoints,
          is_interstate_order: init.is_interstate_order,
          is_return_trip: ended_order.is_return_trip ? "Yes" : "No",
          booked_vehicle_type: init.booked_vehicle_type,
          is_helper_labour_order: init.is_helper_labour_order,
          is_rental_order: init.is_rental_order,
          is_pfe_order: init.is_pfe_order,
          is_otp_order: init.is_otp_order,
          is_order_editable: init.is_order_editable
        };
}

export {
  mapToYesNo ,
  getOpenOrderVm ,
  getVm ,
  
}
/* No side effect */
